import React from "react";
import { useProfile } from "../../../hooks/UserHooks";
import Loader from "../../../components/Loader";
import AppSimpleBar from "../../../components/AppSimpleBar";

import MyProfile from "./MyProfile";
import UserDescription from "./UserDescription";

interface IndexProps { }

const Index = (props: IndexProps) => {
  const { userProfile, loading } = useProfile();

  if (loading) return <Loader />;

  if (!userProfile)
    return (
      <div className="text-center text-danger">
        Não foi possível carregar o perfil.
      </div>
    );

  return (
    <div className="position-relative">

      <MyProfile profile={userProfile} />

      <AppSimpleBar className="p-4 profile-desc">
        <UserDescription profile={userProfile} />
      </AppSimpleBar>

    </div>
  );
};

export default Index;
